/* Golden Goods — small helpers for the phone layout (see gg-mobile.css).
   The carousel prefetch at the bottom runs on every screen size. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  /* "CART (n)" text in the header */
  function cartCount() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    var s = b.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    var n = s ? s.textContent.trim() : (b.querySelector('.cart-count-bubble') ? '99+' : '0');
    if (b.getAttribute('data-gg-count') !== n) b.setAttribute('data-gg-count', n);
  }
  function initCart() {
    cartCount();
    var b = document.getElementById('cart-icon-bubble');
    if (b) new MutationObserver(cartCount).observe(b, { childList: true, subtree: true, characterData: true });
  }

  /* footer link lists become accordions on phones */
  function initFooter() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('.footer .footer-block--menu'));
    blocks.forEach(function (b, i) {
      var h = b.querySelector('.footer-block__heading');
      if (!h || b.classList.contains('gg-acc')) return;
      b.classList.add('gg-acc');
      if (i === blocks.length - 1) b.classList.add('gg-acc--last');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      var toggle = function () { if (mq.matches) b.classList.toggle('is-open'); };
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* dots under the swipeable product rows */
  function initDots() {
    document.querySelectorAll('.gg-pg__scroller .gg-pg__grid').forEach(function (g) {
      if (g.dataset.ggDots) return;
      var items = g.querySelectorAll('.gg-pg__item');
      if (items.length < 3) return;
      g.dataset.ggDots = '1';
      var n = items.length - 1;
      var d = document.createElement('div');
      d.className = 'gg-dots';
      d.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < n; i++) d.appendChild(document.createElement('span'));
      g.parentNode.insertBefore(d, g.nextSibling);
      var upd = function () {
        var w = items[0].getBoundingClientRect().width + 6;
        var idx = Math.min(n - 1, Math.max(0, Math.round(g.scrollLeft / (w || 1))));
        Array.prototype.forEach.call(d.children, function (s, k) { s.classList.toggle('is-on', k === idx); });
      };
      g.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* phones: the image banner is shown above the video carousel */
  function initOrder() {
    if (!mq.matches) return;
    var banner = document.getElementById('shopify-section-gg_image_banner_1');
    var carousel = document.getElementById('shopify-section-gg_videos');
    if (!banner || !carousel || banner.dataset.ggMoved) return;
    if (banner.compareDocumentPosition(carousel) & Node.DOCUMENT_POSITION_PRECEDING) return;
    banner.dataset.ggMoved = '1';
    carousel.parentNode.insertBefore(banner, carousel);
  }

  /* things fade in from the bottom while scrolling -- desktop and phone. */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var sel = [
      '.gg-drag__heading',
      '.gg-drag__text',
      '.gg-drag__button',
      '.gg-imgtext',
      '.gg-imgtext__eyebrow',
      '.gg-imgtext__heading',
      '.gg-imgtext__text',
      '.gg-imgtext__overlay .button',
      '.gg-perks__heading',
      '.gg-perks__item',
      '.gg-rv__score',
      '.gg-rv__title',
      '.gg-rv__item',
      '.gg-pdp__desc',
      '.gg-wordmark__name',
      '.gg-wordmark__tagline'
    ].join(',');
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (!els.length) return;
    /* product grid tiles fade in one after another, not all at once */
    els.forEach(function (el) {
      if (!el.classList.contains('gg-pg__item')) return;
      var grid = el.closest('.gg-pg__grid');
      if (!grid) return;
      var list = grid.ggRevealItems || (grid.ggRevealItems = []);
      list.push(el);
      el.style.transitionDelay = (Math.min(list.length - 1, 5) * 0.05) + 's';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('gg-reveal', 'is-in'); return; }
      el.classList.add('gg-reveal');
      io.observe(el);
    });
  }

  /* story video: keep trying to autoplay it muted, the way phones allow.
     Only a tap on the pause button counts as "the visitor stopped it".
     Performance: it sits far below the hero, so it is NOT started (and its
     ~4 MB is not downloaded) at page load -- only once it is about to scroll
     into view. Until then the poster frame is shown. */
  function initStoryVideo() {
    var wrap = document.querySelector('.gg-story-fullbleed');
    if (!wrap) return;
    var v = wrap.querySelector('video');
    if (!v) return;

    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');

    var stopped = false;
    var started = false;
    var playBtn = wrap.querySelector('[data-story-play]');
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        stopped = !v.paused ? true : false;
      });
    }

    var tryPlay = function () {
      if (stopped) return;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    };

    var start = function () {
      if (started) return;
      started = true;
      v.setAttribute('autoplay', '');
      if (v.preload !== 'auto') v.preload = 'auto';
      tryPlay();
      v.addEventListener('loadeddata', tryPlay);
      v.addEventListener('canplay', tryPlay);
      if (v.readyState === 0) { try { v.load(); } catch (e) {} }
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { start(); if (v.paused) tryPlay(); }
        else if (started && !v.paused) { v.pause(); }
      }, { threshold: 0.2, rootMargin: '150px 0px' }).observe(v);
    } else {
      start();
    }

    ['touchstart', 'touchend', 'click', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, function once() {
        if (started && v.paused) tryPlay();
        window.removeEventListener(evt, once);
      }, { once: true, passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (started && !document.hidden && v.paused) tryPlay();
    });
  }

  /* carousel: start loading a video as soon as a tile is touched or hovered */
  function initCarouselPrefetch() {
    document.querySelectorAll('.gg-drag__slide').forEach(function (s) {
      var v = s.querySelector('video');
      if (!v || s.dataset.ggPrefetch) return;
      s.dataset.ggPrefetch = '1';
      var warm = function () {
        if (v.preload === 'auto') return;
        v.preload = 'auto';
        if (v.readyState === 0) { try { v.load(); } catch (e) {} }
      };
      ['pointerenter', 'touchstart', 'pointerdown'].forEach(function (evt) {
        s.addEventListener(evt, warm, { once: true, passive: true });
      });
    });
  }

  /* left/right arrow buttons that step the swipeable product grid by one tile */
  function initGridArrows() {
    document.querySelectorAll('.gg-pg__scroller').forEach(function (wrap) {
      if (wrap.dataset.ggArrows) return;
      var grid = wrap.querySelector('.gg-pg__grid');
      var prev = wrap.querySelector('.gg-pg__nav--prev');
      var next = wrap.querySelector('.gg-pg__nav--next');
      var items = grid ? grid.querySelectorAll('.gg-pg__item') : [];
      if (!grid || !prev || !next || items.length < 2) return;
      wrap.dataset.ggArrows = '1';
      var step = function (dir) {
        var w = items[0].getBoundingClientRect().width + 12;
        if (dir > 0) {
          var maxScroll = grid.scrollWidth - grid.clientWidth;
          if (grid.scrollLeft >= maxScroll - 8) {
            grid.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
        }
        grid.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });

      /* centre the arrows on the product photo itself, not the whole
         card (photo + title + price + button) */
      var media = items[0].querySelector('.gg-pg__media');
      var placeArrows = function () {
        if (!media) return;
        var h = media.getBoundingClientRect().height;
        prev.style.top = next.style.top = (h / 2) + 'px';
      };
      placeArrows();
      window.addEventListener('resize', placeArrows);

      /* left arrow only makes sense once there is something to scroll back to */
      var updatePrevVisibility = function () {
        prev.style.display = grid.scrollLeft > 8 ? 'flex' : 'none';
      };
      updatePrevVisibility();
      grid.addEventListener('scroll', function () { window.requestAnimationFrame(updatePrevVisibility); }, { passive: true });
    });
  }

  function init() { initOrder(); initCart(); initFooter(); initDots(); initGridArrows(); initReveal(); initStoryVideo(); initCarouselPrefetch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
